export const SCRIPT_SRC = 'https://widget.sparrow.ru/js/embed.js';
